import { z } from 'zod';

export const liveScoresGameSchema = z
	.object({
		homeTeamName: z.string().optional(),
		homeTeamShortName: z.string().optional(),
		homeTeamCrest: z.string().nullable().optional(),
		homeTeamScore: z.number().optional(),
		awayTeamName: z.string().optional(),
		awayTeamShortName: z.string().optional(),
		awayTeamCrest: z.string().nullable().optional(),
		awayTeamScore: z.number().optional(),
		gameStatus: z.string().optional(),
		matchTime: z.string().nullable().optional(),
		kickOffTime: z.string().nullable().optional(),
		groupId: z.number().nullable().optional(),
	})
	.passthrough();

export const liveScoresGroupSchema = z
	.object({
		header: z.string().optional(),
		id: z.number().optional(),
	})
	.passthrough();

export const liveScoresSchema = z
	.object({
		header: z.string().optional(),
		subHeader: z.string().nullable().optional(),
		games: z.array(liveScoresGameSchema).default([]),
		groups: z.array(liveScoresGroupSchema).optional(),
	})
	.passthrough();

export type LiveScoresGame = z.infer<typeof liveScoresGameSchema>;
export type LiveScoresGroup = z.infer<typeof liveScoresGroupSchema>;
export type LiveScores = z.infer<typeof liveScoresSchema>;
